// // D:\MAHAL(UPDATED)-NEW11-04\MAHAL kdsagakhjqsdfk\src\pages\Support\SupportDashboard.js

// import React, {
//   useEffect,
//   useMemo,
//   useState,
//   useCallback
// } from "react";

// import axios from "axios";

// import {
//   ResponsiveContainer,
//   AreaChart,
//   Area,
//   XAxis,
//   YAxis,
//   Tooltip,
//   CartesianGrid,
//   PieChart,
//   Pie,
//   Cell,
//   BarChart,
//   Bar
// } from "recharts";

// import {
//   FaTicketSimple,
//   FaTriangleExclamation,
//   FaClock,
//   FaCircleCheck,
//   FaFireFlameCurved,
//   FaChartLine,
//   FaUserShield,
//   FaRotateRight,
//   FaBell,
//   FaBolt,
//   FaArrowTrendUp,
//   FaUserTie,
//   FaLayerGroup,
//   FaSpinner
// } from "react-icons/fa6";

// import "./SupportDashboard.css";

// const API =
//   "https://api.mahal.qa/api/v1/admin/support";

// const PIE_COLORS = [
//   "#e8f163",
//   "#f59157",
//   "#10b981",
//   "#f59e0b",
//   "#ef4444"
// ];

// export default function SupportDashboard() {

//   const token =
//     localStorage.getItem("admin_token");

//   const [loading, setLoading] =
//     useState(true);

//   const [refreshing, setRefreshing] =
//     useState(false);

//   const [dashboard, setDashboard] =
//     useState({});

//   const [tickets, setTickets] =
//     useState([]);

//   const [slaBreached, setSlaBreached] =
//     useState([]);

//   const [performance, setPerformance] =
//     useState([]);

//   const [admins, setAdmins] =
//     useState([]);

//   const [unread, setUnread] =
//     useState({});


//   const fetchDashboard =
//     useCallback(
//       async (
//         showRefreshLoader = false
//       ) => {

//         try {

//           if (
//             showRefreshLoader
//           ) {
//             setRefreshing(true);
//           } else {
//             setLoading(true);
//           }

//           const headers = {
//             Authorization: `Bearer ${token}`
//           };

//           const requests = [

//             axios.get(
//               `${API}/dashboard`,
//               { headers }
//             ),

//             axios.get(
//               `${API}/tickets`,
//               {
//                 headers,
//                 params: {
//                   limit: 200
//                 }
//               }
//             ),

//             axios.get(
//               `${API}/sla-breached`,
//               { headers }
//             ),

//             axios.get(
//               `${API}/admin-performance`,
//               { headers }
//             ),

//             axios.get(
//               `${API}/unread-count`,
//               { headers }
//             ),

//             axios.get(
//               `${API}/admins`,
//               { headers }
//             )
//           ];

//           const [
//             dashboardRes,
//             ticketsRes,
//             slaRes,
//             performanceRes,
//             unreadRes,
//             adminsRes
//           ] = await Promise.all(
//             requests
//           );

//           setDashboard(
//             dashboardRes.data || {}
//           );

//           setTickets(
//             ticketsRes.data
//               ?.data || []
//           );

//           setSlaBreached(
//             slaRes.data || []
//           );

//           setPerformance(
//             performanceRes.data ||
//             []
//           );

//           setUnread(
//             unreadRes.data || {}
//           );

//           setAdmins(
//             adminsRes.data || []
//           );

//         } catch (error) {

//           console.error(
//             "Dashboard load failed",
//             error
//           );

//         } finally {

//           setLoading(false);

//           setRefreshing(false);
//         }
//       },
//       [token]
//     );



//   useEffect(() => {

//     fetchDashboard();

//     const interval =
//       setInterval(() => {

//         fetchDashboard(true);

//       }, 30000);

//     return () =>
//       clearInterval(interval);

//   }, [fetchDashboard]);



//   const activeTickets =
//     useMemo(
//       () =>
//         tickets.filter(
//           (ticket) =>
//             ![
//               "resolved",
//               "closed"
//             ].includes(
//               ticket.status
//             )
//         ),
//       [tickets]
//     );

//   const escalatedTickets =
//     useMemo(
//       () =>
//         tickets.filter(
//           (ticket) =>
//             (
//               ticket.escalation_level ||
//               0
//             ) > 0
//         ),
//       [tickets]
//     );

//   const highPriorityTickets =
//     useMemo(
//       () =>
//         tickets.filter(
//           (ticket) =>
//             ticket.priority ===
//             "high"
//         ),
//       [tickets]
//     );

//   const queueBreakdown =
//     useMemo(() => {

//       const grouped = {};

//       tickets.forEach(
//         (ticket) => {

//           const key =
//             ticket.queue_name ||
//             "Unknown";

//           grouped[key] =
//             (grouped[key] || 0) +
//             1;
//         }
//       );

//       return Object.keys(
//         grouped
//       ).map((key) => ({
//         name: key,
//         value: grouped[key]
//       }));

//     }, [tickets]);

//   const priorityBreakdown =
//     useMemo(() => {

//       const grouped = {
//         low: 0,
//         normal: 0,
//         high: 0
//       };

//       tickets.forEach(
//         (ticket) => {

//           grouped[
//             ticket.priority
//           ] =
//             (grouped[
//               ticket.priority
//             ] || 0) + 1;
//         }
//       );

//       return [
//         {
//           name: "Low",
//           value: grouped.low
//         },
//         {
//           name: "Normal",
//           value:
//             grouped.normal
//         },
//         {
//           name: "High",
//           value: grouped.high
//         }
//       ];

//     }, [tickets]);

//   const ticketTrend =
//     useMemo(() => {

//       const trendMap = {};

//       tickets.forEach(
//         (ticket) => {

//           const day =
//             new Date(
//               ticket.created_at
//             ).toLocaleDateString();

//           trendMap[day] =
//             (trendMap[day] || 0) +
//             1;
//         }
//       );

//       return Object.keys(
//         trendMap
//       )
//         .slice(-7)
//         .map((key) => ({
//           day: key,
//           tickets:
//             trendMap[key]
//         }));

//     }, [tickets]);

//   const topAdmins =
//     useMemo(
//       () =>
//         [...performance]
//           .sort(
//             (a, b) =>
//               (b.resolved ||
//                 0) -
//               (a.resolved ||
//                 0)
//           )
//           .slice(0, 5),
//       [performance]
//     );



//   const summaryCards = [

//     {
//       title: "Total Tickets",
//       value:
//         dashboard.total || 0,
//       icon: (
//         <FaTicketSimple />
//       ),
//       type: "primary"
//     },

//     {
//       title: "Active",
//       value:
//         activeTickets.length,
//       icon: (
//         <FaRotateRight />
//       ),
//       type: "info"
//     },

//     {
//       title: "Escalated",
//       value:
//         escalatedTickets.length,
//       icon: (
//         <FaTriangleExclamation />
//       ),
//       type: "danger"
//     },

//     {
//       title: "SLA Breached",
//       value:
//         slaBreached.length,
//       icon: <FaClock />,
//       type: "warning"
//     },

//     {
//       title: "High Priority",
//       value:
//         highPriorityTickets.length,
//       icon: (
//         <FaFireFlameCurved />
//       ),
//       type: "critical"
//     },

//     {
//       title: "Unread",
//       value:
//         unread.unread_messages ||
//         0,
//       icon: <FaBell />,
//       type: "purple"
//     }
//   ];



//   if (loading) {

//     return (

//       <div className="sd_loader_wrapper">

//         <div className="sd_loader_box">

//           <FaSpinner className="sd_loader_icon" />

//           <h3>
//             Loading Support Dashboard
//           </h3>

//           <p>
//             Fetching operational
//             analytics...
//           </p>

//         </div>

//       </div>

//     );
//   }



//   return (

//     <div className="sd_page">



//       <div className="sd_topbar">

//         <div>

//           <h1>
//             Support Operations
//           </h1>

//           <p>
//             Real-time support
//             analytics and
//             operational insights
//           </p>

//         </div>

//         <button
//           className={`sd_refresh_btn ${refreshing
//             ? "sd_refreshing"
//             : ""
//             }`}
//           onClick={() =>
//             fetchDashboard(true)
//           }
//           disabled={refreshing}
//         >

//           <FaRotateRight />

//           {/* {refreshing
//             ? "Refreshing..."
//             : "Refresh"} */}

//         </button>

//       </div>



//       <div className="sd_summary_grid">

//         {summaryCards.map(
//           (card, index) => (

//             <div
//               key={index}
//               className={`sd_summary_card ${card.type}`}
//             >

//               <div className="sd_summary_icon">
//                 {card.icon}
//               </div>

//               <div>

//                 <h2>
//                   {card.value}
//                 </h2>

//                 <p>
//                   {card.title}
//                 </p>

//               </div>

//             </div>

//           )
//         )}

//       </div>



//       <div className="sd_chart_grid">



//         <div className="sd_card sd_card_large">

//           <div className="sd_card_header">

//             <h3>
//               Ticket Trend
//             </h3>

//             <FaChartLine />

//           </div>

//           <ResponsiveContainer
//             width="100%"
//             height={320}
//           >

//             <AreaChart
//               data={ticketTrend}
//             >

//               <defs>

//                 <linearGradient
//                   id="sdTrend"
//                   x1="0"
//                   y1="0"
//                   x2="0"
//                   y2="1"
//                 >

//                   <stop
//                     offset="5%"
//                     className="sd_stop_one"
//                   />

//                   <stop
//                     offset="95%"
//                     className="sd_stop_two"
//                   />

//                 </linearGradient>

//               </defs>

//               <CartesianGrid
//                 strokeDasharray="3 3"
//                 className="sd_chart_gridline"
//               />

//               <XAxis dataKey="day" />

//               <YAxis />

//               <Tooltip />

//               <Area
//                 type="monotone"
//                 dataKey="tickets"
//                 stroke="var(--sd-accent-primary)"
//                 fillOpacity={1}
//                 fill="url(#sdTrend)"
//               />

//             </AreaChart>

//           </ResponsiveContainer>

//         </div>



//         <div className="sd_card">

//           <div className="sd_card_header">

//             <h3>
//               Priority Split
//             </h3>

//             <FaBolt />

//           </div>

//           <ResponsiveContainer
//             width="100%"
//             height={320}
//           >

//             <PieChart>

//               <Pie
//                 data={
//                   priorityBreakdown
//                 }
//                 dataKey="value"
//                 outerRadius={110}
//                 label
//               >

//                 {priorityBreakdown.map(
//                   (
//                     entry,
//                     index
//                   ) => (

//                     <Cell
//                       key={index}
//                       fill={
//                         PIE_COLORS[
//                         index
//                         ]
//                       }
//                     />

//                   )
//                 )}

//               </Pie>

//               <Tooltip />

//             </PieChart>

//           </ResponsiveContainer>

//         </div>

//       </div>



//       <div className="sd_bottom_grid">



//         <div className="sd_card">

//           <div className="sd_card_header">

//             <h3>
//               Queue Distribution
//             </h3>

//             <FaLayerGroup />

//           </div>

//           <ResponsiveContainer
//             width="100%"
//             height={320}
//           >

//             <BarChart
//               data={
//                 queueBreakdown
//               }
//             >

//               <CartesianGrid
//                 strokeDasharray="3 3"
//               />

//               <XAxis
//                 dataKey="name"
//               />

//               <YAxis />

//               <Tooltip />

//               <Bar
//                 dataKey="value"
//                 fill="var(--sd-accent-info)"
//                 radius={[
//                   8,
//                   8,
//                   0,
//                   0
//                 ]}
//               />

//             </BarChart>

//           </ResponsiveContainer>

//         </div>



//         <div className="sd_card">

//           <div className="sd_card_header">

//             <h3>
//               Top Admins
//             </h3>

//             <FaUserShield />

//           </div>

//           <div className="sd_admin_list">

//             {topAdmins.length ===
//               0 && (

//                 <div className="support-empty-state">
//                   No performance data
//                 </div>

//               )}

//             {topAdmins.map(
//               (
//                 admin,
//                 index
//               ) => (

//                 <div
//                   key={index}
//                   className="sd_admin_row"
//                 >

//                   <div className="sd_admin_left">

//                     <div className="sd_admin_avatar">

//                       <FaUserTie />

//                     </div>

//                     <div>

//                       <h4>
//                         {
//                           admin.name
//                         }
//                       </h4>

//                       <p>
//                         {admin.queue_name ||
//                           "Support Queue"}
//                       </p>

//                     </div>

//                   </div>

//                   <div className="sd_admin_metrics">

//                     <span>

//                       <FaCircleCheck />

//                       {
//                         admin.resolved
//                       }

//                     </span>

//                     <span>

//                       <FaClock />

//                       {Number(
//                         admin.avg_resolution_hours ||
//                         0
//                       ).toFixed(1)}
//                       h

//                     </span>

//                   </div>

//                 </div>

//               )
//             )}

//           </div>

//         </div>

//       </div>



//       <div className="sd_card">

//         <div className="sd_card_header">

//           <h3>
//             SLA Breaches
//           </h3>

//           <FaTriangleExclamation />

//         </div>

//         <div className="sd_table_wrapper">

//           <table className="sd_table">

//             <thead>

//               <tr>

//                 <th>
//                   Ticket
//                 </th>

//                 <th>
//                   Priority
//                 </th>

//                 <th>
//                   Queue
//                 </th>

//                 <th>
//                   Assigned
//                 </th>

//                 <th>
//                   Escalation
//                 </th>

//                 <th>
//                   SLA Due
//                 </th>

//               </tr>

//             </thead>

//             <tbody>

//               {slaBreached
//                 .slice(0, 10)
//                 .map((ticket) => (

//                   <tr
//                     key={
//                       ticket.ticket_id
//                     }
//                   >

//                     <td>

//                       <div className="support-table-title">

//                         <strong>
//                           #
//                           {
//                             ticket.ticket_id
//                           }
//                         </strong>

//                         <span>
//                           {
//                             ticket.subject
//                           }
//                         </span>

//                       </div>

//                     </td>

//                     <td>

//                       <span
//                         className={`sd_priority ${ticket.priority}`}
//                       >

//                         {
//                           ticket.priority
//                         }

//                       </span>

//                     </td>

//                     <td>
//                       {
//                         ticket.queue_name ||
//                         "-"
//                       }
//                     </td>

//                     <td>
//                       {ticket.assigned_admin_name ||
//                         "Unassigned"}
//                     </td>

//                     <td>

//                       <span className="sd_escalation">

//                         Level{" "}
//                         {
//                           ticket.escalation_level
//                         }

//                       </span>

//                     </td>

//                     <td>

//                       {ticket.sla_due_at
//                         ? new Date(
//                           ticket.sla_due_at
//                         ).toLocaleString()
//                         : "-"}

//                     </td>

//                   </tr>

//                 ))}

//             </tbody>

//           </table>

//         </div>

//       </div>



//       <div className="sd_footer_stats">

//         <div className="sd_footer_card">

//           <FaArrowTrendUp />

//           <div>

//             <h4>
//               {
//                 dashboard.open ||
//                 0
//               }
//             </h4>

//             <p>
//               Open Tickets
//             </p>

//           </div>

//         </div>

//         <div className="sd_footer_card">

//           <FaRotateRight />

//           <div>

//             <h4>
//               {dashboard.in_progress ||
//                 0}
//             </h4>

//             <p>
//               In Progress
//             </p>

//           </div>

//         </div>

//         <div className="sd_footer_card">

//           <FaCircleCheck />

//           <div>

//             <h4>
//               {
//                 dashboard.resolved ||
//                 0
//               }
//             </h4>

//             <p>
//               Resolved
//             </p>

//           </div>

//         </div>

//         <div className="sd_footer_card">

//           <FaUserShield />

//           <div>

//             <h4>
//               {
//                 admins.length
//               }
//             </h4>

//             <p>
//               Active Admins
//             </p>

//           </div>

//         </div>

//       </div>

//     </div>
//   );
// }





// D:\MAHAL(UPDATED)-NEW11-04\MAHAL kdsagakhjqsdfk\src\pages\Support\SupportDashboard.js

import React, { useEffect, useMemo, useState, useCallback } from "react";
import axios from "axios";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar
} from "recharts";
import {
  FaTicketSimple,
  FaTriangleExclamation,
  FaClock,
  FaCircleCheck,
  FaFireFlameCurved,
  FaChartLine,
  FaUserShield,
  FaRotateRight,
  FaBell,
  FaBolt,
  FaArrowTrendUp,
  FaUserTie,
  FaLayerGroup,
  FaSpinner
} from "react-icons/fa6";

import "./Support.css";

const API = "https://api.mahal.qa/api/v1/admin/support";

const ORANGE_COLORS = [
  "#fff7ed",
  "#fed7aa",
  "#fdba74",
  "#fb923c",
  "#f97316",
  "#ea580c"
];

const STATUS_COLORS = {
  low: "#fdba74",
  normal: "#fb923c",
  high: "#ea580c"
};

function toPriority(value) {
  const v = String(value || "").toLowerCase();
  if (v === "high") return "high";
  if (v === "normal") return "normal";
  if (v === "low") return "low";
  return "normal";
}

function safeNumber(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

function safeText(value, fallback = "-") {
  if (value === null || value === undefined || value === "") return fallback;
  return String(value);
}

function formatDate(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleString();
}

function getDayKey(value) {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString().slice(0, 10);
}

function formatDayLabel(dayKey) {
  const d = new Date(`${dayKey}T00:00:00`);
  if (Number.isNaN(d.getTime())) return dayKey;
  return d.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric"
  });
}

function getInitials(name) {
  const clean = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (clean.length === 0) return "A";
  if (clean.length === 1) return clean[0].slice(0, 1).toUpperCase();
  return `${clean[0][0]}${clean[1][0]}`.toUpperCase();
}

function CustomTooltip({ active, payload, label }) {
  if (!active || !payload || !payload.length) return null;

  // return (
  //   <div
  //     style={{
  //       background: "#ffffff",
  //       border: "1px solid #e5e7eb",
  //       borderRadius: 14,
  //       padding: "10px 12px",
  //       boxShadow: "0 12px 24px rgba(15, 23, 42, 0.08)",
  //       color: "#111827"
  //     }}
  //   >
  //     <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 6 }}>{label}</div>
  //     {payload.map((item, index) => (
  //       <div
  //         key={`${item.name || item.dataKey || index}`}
  //         style={{
  //           display: "flex",
  //           alignItems: "center",
  //           gap: 8,
  //           fontSize: 13,
  //           color: "#111827",
  //           marginTop: index === 0 ? 0 : 4
  //         }}
  //       >
  //         <span
  //           style={{
  //             width: 8,
  //             height: 8,
  //             borderRadius: 999,
  //             background: item.color || "#f97316",
  //             display: "inline-block"
  //           }}
  //         />
  //         <span>{item.name || item.dataKey}:</span>
  //         <strong>{item.value}</strong>
  //       </div>
  //     ))}
  //   </div>
  // );
}

export default function SupportDashboard() {
  const token = localStorage.getItem("admin_token");

  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const [dashboard, setDashboard] = useState({});
  const [tickets, setTickets] = useState([]);
  const [slaBreached, setSlaBreached] = useState([]);
  const [performance, setPerformance] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [unread, setUnread] = useState({});

  const fetchDashboard = useCallback(
    async (showRefreshLoader = false) => {
      try {
        if (showRefreshLoader) {
          setRefreshing(true);
        } else {
          setLoading(true);
        }

        const headers = {
          Authorization: `Bearer ${token}`
        };

        const requests = [
          axios.get(`${API}/dashboard`, { headers }),
          axios.get(`${API}/tickets`, {
            headers,
            params: { limit: 200 }
          }),
          axios.get(`${API}/sla-breached`, { headers }),
          axios.get(`${API}/admin-performance`, { headers }),
          axios.get(`${API}/unread-count`, { headers }),
          axios.get(`${API}/admins`, { headers })
        ];

        const [
          dashboardRes,
          ticketsRes,
          slaRes,
          performanceRes,
          unreadRes,
          adminsRes
        ] = await Promise.all(requests);

        setDashboard(dashboardRes.data || {});
        setTickets(ticketsRes.data?.data || []);
        setSlaBreached(slaRes.data || []);
        setPerformance(performanceRes.data || []);
        setUnread(unreadRes.data || {});
        setAdmins(adminsRes.data || []);
      } catch (error) {
        console.error("Dashboard load failed", error);
      } finally {
        setLoading(false);
        setRefreshing(false);
      }
    },
    [token]
  );

  useEffect(() => {
    fetchDashboard();

    const interval = setInterval(() => {
      fetchDashboard(true);
    }, 3000000);

    return () => clearInterval(interval);
  }, [fetchDashboard]);

  const activeTickets = useMemo(
    () =>
      tickets.filter(
        (ticket) => !["resolved", "closed"].includes(String(ticket.status || "").toLowerCase())
      ),
    [tickets]
  );

  const escalatedTickets = useMemo(
    () =>
      tickets.filter((ticket) => safeNumber(ticket.escalation_level) > 0),
    [tickets]
  );

  const highPriorityTickets = useMemo(
    () =>
      tickets.filter((ticket) => toPriority(ticket.priority) === "high"),
    [tickets]
  );

  const queueBreakdown = useMemo(() => {
    const grouped = {};

    tickets.forEach((ticket) => {
      const key = safeText(ticket.queue_name, "Unknown");
      grouped[key] = (grouped[key] || 0) + 1;
    });

    return Object.entries(grouped)
      .map(([name, value]) => ({ name, value }))
      .sort((a, b) => b.value - a.value);
  }, [tickets]);

  const priorityBreakdown = useMemo(() => {
    const grouped = {
      low: 0,
      normal: 0,
      high: 0
    };

    tickets.forEach((ticket) => {
      const priority = toPriority(ticket.priority);
      grouped[priority] = (grouped[priority] || 0) + 1;
    });

    return [
      { name: "Low", value: grouped.low, key: "low" },
      { name: "Normal", value: grouped.normal, key: "normal" },
      { name: "High", value: grouped.high, key: "high" }
    ];
  }, [tickets]);

  const ticketTrend = useMemo(() => {
    const trendMap = {};

    tickets.forEach((ticket) => {
      const dayKey = getDayKey(ticket.created_at);
      if (!dayKey) return;
      trendMap[dayKey] = (trendMap[dayKey] || 0) + 1;
    });

    return Object.entries(trendMap)
      .map(([dayKey, count]) => ({
        dayKey,
        day: formatDayLabel(dayKey),
        tickets: count
      }))
      .sort((a, b) => a.dayKey.localeCompare(b.dayKey))
      .slice(-7);
  }, [tickets]);

  const topAdmins = useMemo(
    () =>
      [...performance]
        .sort((a, b) => (safeNumber(b.resolved) || 0) - (safeNumber(a.resolved) || 0))
        .slice(0, 5),
    [performance]
  );

  const summaryCards = [
    {
      title: "Total Tickets",
      value: safeNumber(dashboard.total),
      icon: <FaTicketSimple />,
      type: "primary"
    },
    {
      title: "Active",
      value: activeTickets.length,
      icon: <FaRotateRight />,
      type: "info"
    },
    {
      title: "Escalated",
      value: escalatedTickets.length,
      icon: <FaTriangleExclamation />,
      type: "danger"
    },
    {
      title: "SLA Breached",
      value: slaBreached.length,
      icon: <FaClock />,
      type: "warning"
    },
    {
      title: "High Priority",
      value: highPriorityTickets.length,
      icon: <FaFireFlameCurved />,
      type: "critical"
    },
    {
      title: "Unread",
      value: safeNumber(unread.unread_messages),
      icon: <FaBell />,
      type: "purple"
    }
  ];

  const openTickets = safeNumber(dashboard.open);
  const inProgressTickets = safeNumber(dashboard.in_progress);
  const resolvedTickets = safeNumber(dashboard.resolved);
  const totalFromTrend = ticketTrend.reduce((sum, item) => sum + safeNumber(item.tickets), 0);

  if (loading) {
    return (
      <div className="support-loader">
        <div className="support-loader-card">
          <div className="support-loader-ring"></div>
          <h3>Loading Support Dashboard</h3>
          <p>Fetching operational analytics...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="support-page">
      <div className="support-header">
        <div className="support-header-content">
          <div className="support-live-tag">
            <span className="support-live-dot"></span>
            Support Command Center
          </div>
          <h1>Support Operations</h1>
          <p>Real-time support analytics and operational insights</p>
        </div>

        <div>
          {/* <div className="support-text-muted">
            Live Refresh
          </div> */}

          <div className="support-text-strong">
            {refreshing}
          </div>


          <button
            className={`support-refresh-btn ${refreshing ? "support-refreshing" : ""}`}
            onClick={() => fetchDashboard(true)}
            disabled={refreshing}
            aria-label="Refresh dashboard"
            title="Refresh dashboard"
          >
            <FaRotateRight />
          </button>
        </div>
      </div>

      <div className="support-summary-grid">
        {summaryCards.map((card, index) => (
          <div className={`support-summary-card is-${card.type}`}>
            <div className="support-summary-icon">{card.icon}</div>
            <div className="support-summary-meta">
              <h2>{card.value}</h2>
              <p>{card.title}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="support-chart-grid">
        <div className="support-panel support-panel--mid">
          <div className="support-panel-header">
            <div className="support-panel-title">
              <span>Trend</span>
              <h3>Ticket Trend</h3>
            </div>
            <FaChartLine />
          </div>

          <ResponsiveContainer width="100%" height={320}>
            <AreaChart data={ticketTrend}>
              <defs>
                <linearGradient id="sdTrendOrange" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#f97316" stopOpacity={0.35} />
                  <stop offset="95%" stopColor="#f97316" stopOpacity={0.02} />
                </linearGradient>
              </defs>

              <CartesianGrid
                strokeDasharray="3 3"
                className="support-chart-gridline"
              />
              <XAxis dataKey="day" />
              <YAxis allowDecimals={false} />
              <Tooltip content={<CustomTooltip />} />
              <Area
                type="monotone"
                dataKey="tickets"
                name="Tickets"
                stroke="#f97316"
                strokeWidth={3}
                fill="url(#sdTrendOrange)"
                dot={{ r: 3, fill: "#f97316", stroke: "#ffffff", strokeWidth: 2 }}
                activeDot={{ r: 6 }}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>

        <div className="support-panel support-panel--mid">
          <div className="support-panel-header">
            <div>
              <div className="support-panel-title">Priority Mix</div>
              {/* <span>Priority Mix</span> */}
            </div>
            <FaBolt />
          </div>

          <div className="support-donut-wrap">
            <ResponsiveContainer width="100%" height={320}>
              <PieChart>
                <Pie
                  data={priorityBreakdown}
                  dataKey="value"
                  nameKey="name"
                  innerRadius={78}
                  outerRadius={116}
                  paddingAngle={4}
                  stroke="#ffffff"
                  strokeWidth={4}
                >
                  {priorityBreakdown.map((entry, index) => (
                    <Cell
                      key={entry.key || index}
                      fill={ORANGE_COLORS[index + 1] || ORANGE_COLORS[ORANGE_COLORS.length - 1]}
                    />
                  ))}
                </Pie>
                <Tooltip content={<CustomTooltip />} />
              </PieChart>
            </ResponsiveContainer>

            <div className="support-donut-center">
              <span>Total Tickets</span>

              <strong>
                {safeNumber(dashboard.total)}
              </strong>

              <p>
                {totalFromTrend || safeNumber(dashboard.total)} tracked
              </p>
            </div>
          </div>

          <div className="support-chart-legend">
            {priorityBreakdown.map((item, index) => (
              <div key={item.key || index} className="support-legend-item">
                <span
                  className="support-legend-dot"
                  style={{ background: ORANGE_COLORS[index + 1] || "#f97316" }}
                />
                <span>{item.name}</span>
                <strong>{item.value}</strong>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="support-panel-grid">
        <div className="support-panel support-panel--mid">
          <div className="support-panel-header">
            <div>
              <div className="support-panel-title">
                <span>QUEUE ANALYTICS</span>
                <h3>Queue Distribution</h3>
              </div>
            </div>
            <FaLayerGroup />
          </div>

          <ResponsiveContainer width="100%" height={320}>
            <BarChart data={queueBreakdown}>
              <CartesianGrid
                strokeDasharray="3 3"
                className="support-chart-gridline"
              />
              <XAxis dataKey="name" interval={0} tick={{ fill: "#111827", fontSize: 12 }} />
              <YAxis allowDecimals={false} tick={{ fill: "#111827", fontSize: 12 }} />
              <Tooltip content={<CustomTooltip />} />
              <Bar dataKey="value" name="Tickets" radius={[10, 10, 0, 0]}>
                {queueBreakdown.map((entry, index) => (
                  <Cell
                    key={`${entry.name}-${index}`}
                    fill={ORANGE_COLORS[Math.min(index + 2, ORANGE_COLORS.length - 1)]}
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className="support-panel support-panel--mid">
          <div className="support-panel-header">
            <div>
              <div className="support-panel-title">Performance</div>
              <h3>Top Admins</h3>
            </div>
            <FaUserShield />
          </div>

          <div className="support-top-list">
            {topAdmins.length === 0 && <div className="support-empty-state">No performance data</div>}

            {topAdmins.map((admin, index) => {
              const resolved = safeNumber(admin.resolved);
              const avgHours = Number(admin.avg_resolution_hours || 0).toFixed(1);

              return (
                <div key={`${admin.name || "admin"}-${index}`} className="support-top-row">
                  <div className="support-user-info">
                    <div className="support-avatar">{getInitials(admin.name)}</div>
                    <div className="support-user-info">
                      <h4>{safeText(admin.name, "Admin")}</h4>
                      <p>{safeText(admin.queue_name, "Support Queue")}</p>
                    </div>
                  </div>

                  <div className="support-score-box">
                    <span>
                      <FaCircleCheck />
                      {resolved}
                    </span>
                    <span>
                      <FaClock />
                      {avgHours}h
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="support-panel1">
        <div className="support-panel-header">
          <div>
            <div className="support-panel-title"></div>
            <h3>SLA Breaches</h3>
          </div>
          <FaTriangleExclamation />
        </div>

        <div className="support-table-wrap">
          <table className="support-table">
            <thead>
              <tr>
                <th>Ticket</th>
                <th>Priority</th>
                <th>Queue</th>
                <th>Assigned</th>
                <th>Escalation</th>
                <th>SLA Due</th>
              </tr>
            </thead>

            <tbody>
              {slaBreached.slice(0, 10).map((ticket) => {
                const priority = toPriority(ticket.priority);
                return (
                  <tr key={ticket.ticket_id}>
                    <td>
                      <div className="support-table-title">
                        <strong>#{safeText(ticket.ticket_id, "-")}</strong>
                        <span>{safeText(ticket.subject, "Untitled ticket")}</span>
                      </div>
                    </td>

                    <td>
                      <span className={`support-priority ${priority}`}>{priority}</span>
                    </td>

                    <td>{safeText(ticket.queue_name, "-")}</td>

                    <td>{safeText(ticket.assigned_admin_name, "Unassigned")}</td>

                    <td>
                      <span className="support-badge is-critical">
                        Level {safeNumber(ticket.escalation_level)}
                      </span>
                    </td>

                    <td>{formatDate(ticket.sla_due_at)}</td>
                  </tr>
                );
              })}

              {slaBreached.length === 0 && (
                <tr>
                  <td colSpan={6}>
                    <div className="support-empty-state">No SLA breaches right now</div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="support-footer-stats">
        <div className="support-footer-card">
          <FaArrowTrendUp />
          <div>
            <h4>{openTickets}</h4>
            <p>Open Tickets</p>
          </div>
        </div>

        <div className="support-footer-card">
          <FaRotateRight />
          <div>
            <h4>{inProgressTickets}</h4>
            <p>In Progress</p>
          </div>
        </div>

        <div className="support-footer-card">
          <FaCircleCheck />
          <div>
            <h4>{resolvedTickets}</h4>
            <p>Resolved</p>
          </div>
        </div>

        <div className="support-footer-card">
          <FaUserShield />
          <div>
            <h4>{admins.length}</h4>
            <p>Active Admins</p>
          </div>
        </div>
      </div>
    </div>
  );
}